import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import useSound from 'use-sound';

import {
    Routes,
    Route,
    Outlet,
    useNavigate,
    Link,
} from "react-router-dom";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import {
    Button,
    Typography,
    LinearProgress,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableHead,
    Chip,
    Grid,
    ButtonBase,
    CardContent,
    Card,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    AppBar,
} from "@mui/material";
import {
    TableContainer, IconButton, Collapse
} from '@mui/material';
import { Inbox, KeyboardArrowDown, KeyboardArrowUp, Mail } from '@mui/icons-material';

import Paper from '@mui/material/Paper';

import Alert from '@mui/material/Alert';
import useWebSocket from 'react-use-websocket';
import { useCookies } from 'react-cookie';

import errorSound from '../sounds/error.mp3';
import successSound from '../sounds/success.mp3';
import openSound from '../sounds/open.mp3';

import inventorysuccessSound from '../sounds/inventorysuccess.mp3';
import scanSound from '../sounds/scan.mp3';

import { East, ViewTimeline } from "@mui/icons-material";
import { ShipmentHistoryButton } from "./Checkout";
import { WarehouseModalIconButton, WarehouseSlotHistoryView } from "./WarehouseSlotHistory";
import LagerplatzDetails from "./LagerplatzDetails";

import WarehouseIcon from '@mui/icons-material/Warehouse';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import InventoryProgress from "./Inventur/InventoryProgress";


const socketUrl = 'wss://brmm0q8jaa.execute-api.eu-central-1.amazonaws.com/production';


const InventoryLayout = () => {
    const [open, setOpen] = useState(false);
    const [cookies, setCookie] = useCookies(['checkinDeviceId']);
    const [temp, setTemp] = useState(cookies.checkinDeviceId);

    const save = () => {
        const expires = new Date(Date.now() + 60 * 60 * 24 * 366 * 1000)
        setCookie('checkinDeviceId', temp, { path: '/', expires })
    };
    const appBarHeight = 64
    const navigate = useNavigate();
    return (
        <>
        <AppBar variant="outlined" position="sticky" sx={{my:2}}>

                <List sx={{display:'flex', color: 'white'}}>

                    <ListItem disablePadding>
                        <ListItemButton onClick={()=>navigate('/inventur')}>
                            <ListItemIcon>
                                <Inbox />
                            </ListItemIcon>
                            <ListItemText primary={"Inventur"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton onClick={()=>navigate('/inventur/report')}>
                            <ListItemIcon>
                                <Inbox />
                            </ListItemIcon>
                            <ListItemText primary={"Report"} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton onClick={()=>navigate('/warehouse')}>
                            <ListItemIcon>
                                <Inbox />
                            </ListItemIcon>
                            <ListItemText primary={"Lager"} />
                        </ListItemButton>
                    </ListItem>


                </List>
        </AppBar>
            <Box sx={{ display: 'flex', gap: 2, pb: 2, pt: 1 }}>
                <Typography variant="h6" gutterBottom>Inventur</Typography>
                <Button onClick={() => setOpen(!open)} size="small" variant="outlined">DID: {cookies.checkinDeviceId}</Button>

            
            </Box>
            {open && <Alert severity="error" sx={{ p: 2, mb: 2, maxWidth: '500px' }}><Typography>Device ID (10-99) Festlegen</Typography><TextField value={temp} onChange={(evt) => { setTemp(evt.target.value) }} /><Button disabled={temp.length !== 2} onClick={save}>Speichern</Button></Alert>}
            <Outlet />
        </>
    )
}
export {InventoryLayout}

const Inventur = ({ posConfig }) => {
    return (
        <>
            <Routes>
                <Route path="/" element={<InventoryLayout />}>
                    <Route index element={<SlotInventory posConfig={posConfig} />} />
                    <Route path=":customerId" element={<EditShipment posConfig={posConfig} />} />
                </Route>
            </Routes>
        </>
    )
}

export default Inventur;


const SlotInventory = ({ posConfig }) => {

    const [cookies, setCookie] = useCookies(['checkinDeviceId']);
    const [temp, setTemp] = useState("");

    const save = () => {
        const expires = new Date(Date.now() + 60 * 60 * 24 * 366 * 1000)
        setCookie('checkinDeviceId', temp, { path: '/', expires })
    };

    if (!cookies.checkinDeviceId) {
        return <Paper sx={{ p: 2 }}><Typography>Device ID (10-99) Festlegen</Typography><TextField onChange={(evt) => { setTemp(evt.target.value) }} /><Button disabled={temp.length !== 2} onClick={save}>Speichern</Button></Paper>
    }



    return (
        <StoreShipmentApp posConfig={posConfig} />
    )
}


const EditShipment = () => { };




const StoreShipmentApp = ({ posConfig }) => {


    const [cookies] = useCookies(['secret', 'station', 'staff', 'checkinDeviceId']);
    const sidInputRef = useRef(null);

    const [comment, setComment] = useState({})
    const { sendMessage, readyState } = useWebSocket(socketUrl,
        {
            queryParams: {
                station: posConfig.connection.station,
                secret: cookies.secret,
                staff: cookies.staff
            },
            onMessage: (message) => handleWebsocketEvent(message),
            shouldReconnect: (_closeEvent) => true,
            retryOnError: true,
            onClose: () => console.log('closing'),
            onError: (err) => console.log('error', err),
            onReconnectStop: (err) => console.log('recon stop', err),
        }
    );


    const sendFinishInventory = (slot, dbFields) => {
        sendMessage(JSON.stringify({ task: 'finishInventory', station: posConfig.connection.station, staff: cookies.staff, location_id: slot, did: cookies.checkinDeviceId, last_inventory_by: cookies.staff, ...dbFields }))
    };


    const getSlotDetails = (slot) => {
        setSlotDetails(null);
        sendMessage(JSON.stringify({ task: 'getSlotDetails', station: posConfig.connection.station, staff: cookies.staff, slot, did: cookies.checkinDeviceId }))
    };

    const getInventoryReport = () => {
        sendMessage(JSON.stringify({ task: 'getInventoryReport', station: posConfig.connection.station, staff: cookies.staff, slot, did: cookies.checkinDeviceId }))
    };

    const trackInventoryScan = ({ location_id, mpsid }) => {
        sendMessage(JSON.stringify({ task: 'trackInventoryScan', station: posConfig.connection.station, staff: cookies.staff, did: cookies.checkinDeviceId, location_id, mpsid }))
    };




    const [inventoryReport, setInventoryReport] = useState();

    useEffect(() => {
        getInventoryReport();
    }, [])


    const handleWebsocketEvent = (lastMessage) => {

        const msg = JSON.parse(lastMessage.data)
        console.log(msg)

        if (msg.task === 'respFinishInventory') {
            setSlotDetails(null);
            setInventurDetails({ expected: {}, unexpected: [] });
            playSuccess();
            setValue("");
            setSlot(null);
            setComment({ msg: "Fach abgeschloßen!", type: 'success' })
            sidInputRef.current.focus();
            getInventoryReport();
        }

        if (msg.task === 'respGetSlotDetails') {
            setInventurDetails({
                expected: msg.items.reduce((p, v) => {
                    p[v.id] = 0;
                    return p;
                }, {}),
                unexpected: []
            });
            setSlotDetails(msg);
        }

        if (msg.task === 'respGetInventoryReport') {
            setInventoryReport(msg);
        }



    };


    const checkX = (str) => {
        let hadX = false;
        if (str[0] === "x" && str[str.length - 1] === "x") {
            hadX = true;
            str = str.slice(1, -1);
        }
        return {
            input: str,
            hadX: hadX
        };
    }

    const [slot, setSlot] = useState(null);
    const [slotDetails, setSlotDetails] = useState(null);

    const [value, setValue] = useState("");

    const [inventurDetails, setInventurDetails] = useState({ expected: {}, unexpected: [] });

    const finishInventur = () => {
        const dbFields = convertInventurDetailsToDbFields(inventurDetails);
        sendFinishInventory(slot, dbFields)
    };

    const inventurTrackShipment = (slot, mpsid) => {

        playScan();
        setValue("");
        sidInputRef.current.focus();
        setComment({ msg: "Erfasst ", type: 'success' })

        if (mpsid in inventurDetails.expected) {
            setInventurDetails({
                expected: {
                    ...inventurDetails.expected,
                    [mpsid]: inventurDetails.expected[mpsid] + 1
                },
                unexpected: inventurDetails.unexpected,
            })
        } else {
            setInventurDetails({
                expected: inventurDetails.expected,
                unexpected: (inventurDetails.unexpected.length > 0 ? [...inventurDetails.unexpected, mpsid] : [mpsid]),
            })
        }

        trackInventoryScan({ location_id: slot, mpsid })

    };

    const handleScanEvent = (val) => {
        if (checkX(val)) {

            if (val.length === 7) {
                const tmp = val.replaceAll('x', '');
                setSlot(tmp);
                getSlotDetails(tmp);
                sidInputRef.current.focus();
                playOpen();
                setValue("");
                setComment({ msg: "Lager für Inventur offen", type: 'success' })
            } else {
                if (slot === null) {
                    playError();
                    setComment({ msg: "FEHLER - Kein Lager offen", type: 'error' })
                } else {

                    if (val === 'CLOSECLOSE') {
                        finishInventur(slot);
                    } else if (val.length > 8) {
                        //relocateShipment(slot, val.replaceAll('x', ''));
                        inventurTrackShipment(slot, val.replaceAll('x', ''))
                    } else {
                        playError();
                        setComment({ msg: "FEHLER - MPSID zu kurz", type: 'error' })
                        setValue("");
                    }
                }
            }


        } else {
            playError();
            setValue("");
            setComment({ msg: "FEHLER - Kein Barcode", type: 'error' })
        }
    };

    useEffect(() => {
        if (value === "") {
            sidInputRef.current.focus();
        }
    }, [value])

    const [playError, { stop1 }] = useSound(errorSound);
    const [playSuccess, { stop2 }] = useSound(inventorysuccessSound);
    const [playScan, { stop4 }] = useSound(scanSound);
    const [playOpen, { stop3 }] = useSound(openSound);

    const staffMap = slotDetails?.staffInfo?.reduce((p, c) => {
        p[c.id] = c.vorname + ' ' + c.nachname;
        return p;
    }, {});

    const warehouseMap = slotDetails?.warehouseInfo?.reduce((p, c) => {
        p[c.id] = c.text;
        return p;
    }, {});

    return (
        <Box>
            <Paper sx={{ mb: 4, p: 4 }} >

                <TextField
                    inputRef={sidInputRef}
                    onMouseEnter={() => { sidInputRef.current.focus(); }}
                    fullWidth
                    onKeyPress={(evt) => {
                        if (evt.charCode === 13) {
                            handleScanEvent(evt.target.value)
                        }
                    }}
                    autoComplete="off"
                    size="small"
                    value={value}
                    onChange={(evt) => setValue(evt.target.value)}
                />
                {!!comment?.msg && <Alert sx={{ mt: 2 }} severity={comment.type}>{comment.msg}</Alert>}
                {!!slot && slotDetails === null && <LinearProgress sx={{ mt: 2 }} variant="indeterminate" />}
                {slotDetails !== null && <>
                    <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Sendungen in {slotDetails.name}</Typography>
                    <WarehouseModalIconButton slot={slot} />
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>MPSID</TableCell>
                                <TableCell>Eingangsdatum</TableCell>
                                <TableCell>KDNR</TableCell>
                                <TableCell>Vorname</TableCell>
                                <TableCell>Nachname</TableCell>
                                <TableCell>Klasse</TableCell>
                                <TableCell>Sendungsnummer</TableCell>
                                <TableCell>Absender</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {slotDetails.items.map((e, i) => {
                                return (<TableRow key={i} sx={{ backgroundColor: inventurDetails.expected[e.id] > 0 ? 'rgb(237, 247, 237)' : 'inherit' }}>
                                    <TableCell>{e.id} <ShipmentHistoryButton id={e.id} /></TableCell>
                                    <TableCell>{new Date(e.creationdate).toLocaleString('de-DE')}</TableCell>
                                    <TableCell>{e.kdnr}</TableCell>
                                    <TableCell>{e.firstname}</TableCell>
                                    <TableCell>{e.lastname}</TableCell>
                                    <TableCell>{e.klasse}</TableCell>
                                    <TableCell>{e.sendungsnummer}</TableCell>
                                    <TableCell>{e.absender}</TableCell>
                                </TableRow>);
                            })}
                            {inventurDetails.unexpected.map((e, i) => {
                                return (<TableRow key={i} sx={{ backgroundColor: 'rgb(247, 237, 237)' }}>
                                    <TableCell>{e} <ShipmentHistoryButton id={e} /></TableCell>
                                    <TableCell> </TableCell>
                                    <TableCell> </TableCell>
                                    <TableCell> </TableCell>
                                    <TableCell> </TableCell>
                                    <TableCell> </TableCell>
                                    <TableCell> </TableCell>
                                    <TableCell> </TableCell>
                                </TableRow>);
                            })}
                        </TableBody>
                    </Table>
                </>}
                {slotDetails?.history.length &&
                    <WarehouseSlotHistoryView slot={slot} staffMap={staffMap} warehouseMap={warehouseMap} history={slotDetails.history} preview={true} />
                }
            </Paper>

            {inventoryReport &&
                <InventoryReport results={inventoryReport.result} />
            }
        </Box>
    );
}



function convertInventurDetailsToDbFields(inventurDetails) {
    const expected = inventurDetails.expected || {};
    const unexpected = inventurDetails.unexpected || [];

    let missingCount = 0;
    let duplicateCount = 0;

    for (const scan in expected) {
        const count = expected[scan];
        if (count === 0) {
            missingCount += 1;
        } else if (count > 1) {
            duplicateCount += 1;
        }
    }

    const unexpectedCount = unexpected.length;
    const hasIssues = missingCount > 0 || duplicateCount > 0 || unexpectedCount > 0;

    const result = {
        last_inventory_at: new Date().toISOString().slice(0, 19).replace('T', ' '), // MySQL DATETIME
        missing_count: missingCount,
        duplicate_count: duplicateCount,
        unexpected_count: unexpectedCount,
        has_issues: hasIssues,
        inventory_result: JSON.stringify(inventurDetails)
    };

    return result;
}


const InventoryReport = ({ results }) => {
    if (!results || results.length === 0) {
        return <div className="p-4 text-gray-600">Keine Inventur Vorgänge gefunden.</div>;
    }

    return (
        <Box>
            <Typography variant="h5" gutterBottom>Einzelberichte</Typography>
            <TableContainer component={Paper}>
                <Table size="small" aria-label="inventory report table">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell />
                            <TableCell>Location</TableCell>
                            <TableCell>Last Inventory</TableCell>
                            <TableCell>By</TableCell>
                            <TableCell align="center">Missing</TableCell>
                            <TableCell align="center">Duplicates</TableCell>
                            <TableCell align="center">Unexpected</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((row, idx) => (
                            <InventoryRow key={idx} row={row} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

const InventoryRow = ({ row }) => {
    const [open, setOpen] = useState(false);

    const {
        id,
        text,
        last_inventory_at,
        vorname,
        nachname,
        missing_count,
        duplicate_count,
        unexpected_count,
        inventory_result
    } = row;

    const user = vorname || nachname ? `${vorname || ''} ${nachname || ''}`.trim() : '—';

    const inventory = inventory_result;
    const expectedEntries = Object.entries(inventory.expected || {});
    const unexpectedEntries = inventory.unexpected || [];


    return (
        <>
            <TableRow hover>
                <TableCell>
                    <IconButton size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    </IconButton>
                </TableCell>
                <TableCell sx={{ fontFamily: 'monospace' }}>{text}</TableCell>
                <TableCell>{last_inventory_at}</TableCell>
                <TableCell>{user}</TableCell>
                <TableCell align="center" sx={{ color: missing_count > 0 ? 'error.main' : 'text.primary' }}>
                    {missing_count}
                </TableCell>
                <TableCell align="center" sx={{ color: duplicate_count > 0 ? 'warning.main' : 'text.primary' }}>
                    {duplicate_count}
                </TableCell>
                <TableCell align="center" sx={{ color: unexpected_count > 0 ? 'warning.dark' : 'text.primary' }}>
                    {unexpected_count}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={7} sx={{ p: 0, border: 0 }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ m: 2, p: 2, bgcolor: '#fafafa', border: '1px solid #ddd', borderRadius: 1 }}>
                            <Typography variant="subtitle2" gutterBottom>Inventory Details</Typography>

                            {/* Erwartete Sendungen */}
                            <Typography variant="body2" sx={{ mt: 1, mb: 0.5, fontWeight: 500 }}>
                                Expected Shipments
                            </Typography>
                            <Table size="small" sx={{ mb: 2 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tracking Number</TableCell>
                                        <TableCell align="center">Scans</TableCell>
                                        <TableCell>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {expectedEntries.map(([sid, count], idx) => (
                                        <TableRow key={idx}>
                                            <TableCell sx={{ fontFamily: 'monospace' }}>{sid} <ShipmentHistoryButton id={sid} /></TableCell>
                                            <TableCell align="center">{count}</TableCell>
                                            <TableCell>
                                                {count === 0 && <span style={{ color: 'red' }}>Missing</span>}
                                                {count === 1 && <span style={{ color: 'green' }}>OK</span>}
                                                {count > 1 && <span style={{ color: 'orange' }}>Duplicate</span>}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>

                            {/* Unerwartete Sendungen */}
                            {unexpectedEntries.length > 0 && (
                                <>
                                    <Typography variant="body2" sx={{ mt: 2, mb: 0.5, fontWeight: 500 }}>
                                        Unexpected Shipments
                                    </Typography>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Tracking Number</TableCell>
                                                <TableCell>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {unexpectedEntries.map((sid, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell sx={{ fontFamily: 'monospace' }}>{sid}</TableCell>
                                                    <TableCell><span style={{ color: 'darkorange' }}>Not expected here</span></TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </>
                            )}
                        </Box>
                    </Collapse>

                </TableCell>
            </TableRow>
        </>
    );
};

